// @ts-check
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import useSiteConfig from '../../../../src/components/useSiteConfig';
import { useTastingNotes } from '../../../gatsby-plugin-tastingnotes/src/useTastingNote';
import useBookmarksByExhibitor from '../useBookmarksByExhibitor';

export default function useMyListQuery({ query, locale, collectionId }) {
  const bookmarks = useBookmarksByExhibitor();
  const tastingNotes = useTastingNotes();
  const { myListDataUri } = useSiteConfig();
  // We need to convert this to a string so that useEffect doesn't trigger multiple times
  const companyIds = bookmarks.exhibitors.map((b) => b.exhibitorId).join(',');

  // const result = useQuery(query, {
  //   variables: { companyIds, collectionId, locale },
  // });

  // We need to bypass Apollo here because it doesn't seem to handle multiple queries
  // There is also no real benefit to using cache because we are selectively querying data, and reloading it each time.
  const [result, setResult] = useState({
    loading: true,
    data: null,
    error: null,
  });

  useEffect(() => {
    async function fetchData() {
      //@ts-ignore
      const response = await fetch(myListDataUri, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: query?.loc?.source?.body,
          variables: {
            // Convert back to an array
            companyIds: companyIds?.split(','),
            collectionId,
            locale,
          },
        }),
      });
      const result = await response.json();
      setResult({
        ...result,
        data: result.data,
        loading: false,
        error: result.errors,
      });
    }
    fetchData();
  }, [
    collectionId,
    companyIds,
    locale,
    myListDataUri,
    query?.loc?.source?.body,
  ]);

  if (!result.data) return result;
  const sections = result.data?.collection?.catalog?.sections?.map(
    (section) => {
      const bookmark = bookmarks.get(section.registration?.companyId);
      return {
        ...section,
        registration: section.registration && {
          ...section.registration,
          bookmark: bookmark?.bookmark,
          registeredProducts: {
            ...section.registration?.registeredProducts,
            nodes: section.registration?.registeredProducts.nodes?.map(
              (registeredProduct) => ({
                ...registeredProduct,
                bookmark: bookmark?.products?.find(
                  (bookmark) => bookmark.id === registeredProduct.productId
                ),
                tastingNote: tastingNotes.byId[registeredProduct.productId],
              })
            ),
          },
        },
      };
    }
  );
  return {
    ...result,
    data: {
      ...result.data,
      collection: {
        ...result.data?.collection,
        catalog: {
          ...result.data?.collection?.catalog,
          sections,
        },
      },
    },
  };
}
